"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @param product the product that should be remapped from the graphQL structure to the Product component structure
 * @param outputElementNo If more than one RecoSlider exists on the page the slider has to "know" which position it has to send that position to tracking
 */
var getClickTrackingURLExtension = function (_a) {
    var sourceArticleNo = _a.sourceArticleNo, targetOrderNumber = _a.targetOrderNumber, cid = _a.cid, outputElementNo = _a.outputElementNo, position = _a.position, pageTemplate = _a.pageTemplate, productsToLoad = _a.productsToLoad, recoLogic = _a.recoLogic, rdeType = _a.rdeType;
    // To support click tracking the URL has to be extended with the needed parameters
    var urlExtension = 
    // eslint-disable-next-line prefer-template
    '&ref=reco&lmPromo=la,1,hk,' +
        pageTemplate +
        ',fl,' +
        (rdeType + "_") +
        productsToLoad +
        '_' +
        position +
        '_' +
        cid +
        '_' +
        sourceArticleNo +
        '_' +
        targetOrderNumber +
        '_' +
        recoLogic +
        '_' +
        'OutputElement' +
        outputElementNo;
    return urlExtension;
};
exports.default = getClickTrackingURLExtension;
//# sourceMappingURL=getClickTrackingURLExtension.js.map